export default {
  name: 'ContactsPage',
  page() {
    return {
      title: this.$i18n.t('contacts.title'),
    };
  },
  computed: {
    contactsCard() {
      return [{
        id: 'partners',
        title: this.$i18n.t('contacts.cards.partners.title'),
        text: this.$i18n.t('contacts.cards.partners.text'),
        email: window.atob('Yml6ZGV2QG15LmdhbWVz'),
      }, {
        id: 'media',
        title: this.$i18n.t('contacts.cards.media.title'),
        text: this.$i18n.t('contacts.cards.media.text'),
        email: window.atob('cHJAbXkuZ2FtZXM='),
      }, {
        id: 'integrations',
        title: this.$i18n.t('contacts.cards.integrations.title'),
        text: this.$i18n.t('contacts.cards.integrations.text', { project: 'MY.GAMES Store' }),
        email: window.atob('aW50ZWdyYXRpb25AbXkuZ2FtZXM='),
      }, {
        id: 'support',
        title: this.$i18n.t('contacts.cards.support.title'),
        text: this.$i18n.t('contacts.cards.support.text', { project: 'MY.GAMES' }),
        supportLink: 'https://support.my.games'
      }];
    },
  },
};
